import { Badge, Button } from "antd";
import { NotificationOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import useNotifications from "../../hooks/useNotifications";
import { appRoutes } from "../../constants/routes";

const Notifications = (props:{ outlined?: boolean }) => {
  const { outlined = false } = props;
  const { notificationsData } = useNotifications();

  return (
    <Link to={appRoutes.messages}>
      {outlined ? (
        <Button type="link" size="large">
          <Badge size="small" count={notificationsData} color="#36CFC9">
            <NotificationOutlined style={{ fontSize: 19, color: "#FFFFFF" }}/>
          </Badge>
        </Button>
      ) : (
        <Badge count={notificationsData} color="#36CFC9">
          <Button type="link" size="large" icon={<NotificationOutlined />} style={{ background: "#FFFFFF" }}/>
        </Badge>
      )}
    </Link>
  );
};

export default Notifications;
